module.exports = __webpack_public_path__ + "static/media/feiyang_zhang.96dbaf92.jpg";